// extracted by mini-css-extract-plugin
export default {"main":"Main_main__OVpPo","content":"Main_content__YMz4e"};